/* ==========================================================
   MEGA MENU — frecce del carosello

   Lo stile sta in assets/cube-megamenu.css; qui c'e' solo il comportamento:
   aggiungere le due frecce a ogni pannello e tenerle aggiornate.

   Due cose meno ovvie di quanto sembri:

   1. I pannelli sono nascosti finche' non ci passi sopra, e un elemento
      nascosto misura zero. Calcolare una volta sola al caricamento darebbe
      numeri sbagliati per sempre, quindi si osserva il binario con un
      ResizeObserver: quando il pannello si apre cambia dimensione e le misure
      si rifanno da sole.

   2. Le frecce vanno all'altezza dell'immagine, non del pannello: le liste
      di modelli hanno lunghezze molto diverse e centrarle sul pannello le
      farebbe ballare da una categoria all'altra.
   ========================================================== */

(function () {
  'use strict';

  var SPAZIO = 22; // lo stesso gap del CSS

  // restituisce true se il pannello e' pronto (adesso o da prima),
  // false se il binario non c'e' ancora e va ritentato piu' tardi
  function prepara(mega) {
    var pista = mega.querySelector('.mega-menu__list');
    if (!pista) return false;
    if (pista.dataset.cubeCarosello) return true;
    pista.dataset.cubeCarosello = '1';

    var indietro = creaFreccia('indietro', '‹', 'Categorie precedenti');
    var avanti = creaFreccia('avanti', '›', 'Categorie successive');
    mega.appendChild(indietro);
    mega.appendChild(avanti);

    function creaFreccia(verso, segno, etichetta) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cube-mm-freccia cube-mm-freccia--' + verso;
      b.setAttribute('aria-label', etichetta);
      b.textContent = segno;
      b.hidden = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pista.scrollBy({ left: (verso === 'indietro' ? -1 : 1) * passo(), behavior: 'smooth' });
      });
      return b;
    }

    function passo() {
      var scheda = pista.querySelector('.mega-menu__column');
      return scheda ? scheda.getBoundingClientRect().width + SPAZIO : 320;
    }

    function aggiorna() {
      var scorrimento = pista.scrollWidth - pista.clientWidth;
      // se le categorie ci stanno tutte non serve nessuna freccia
      var serve = scorrimento > 8;

      // tolleranza di 8px: lo scorrimento agganciato non si ferma mai
      // esattamente sullo zero o sul fondo
      indietro.hidden = !serve || pista.scrollLeft <= 8;
      avanti.hidden = !serve || pista.scrollLeft >= scorrimento - 8;

      var riferimento = pista.querySelector('.mega-menu__link--parent');
      if (!riferimento) return;
      var immagine = riferimento.querySelector('.mega-menu__link-image');
      // senza foto l'altezza del riquadro e' 3/4 della larghezza (4:3)
      var alta = immagine
        ? immagine.getBoundingClientRect().height
        : riferimento.getBoundingClientRect().width * 0.75;
      if (!alta) return;

      var cima = pista.offsetTop + alta / 2 - 23; // 23 = meta' della freccia
      indietro.style.top = cima + 'px';
      avanti.style.top = cima + 'px';
    }

    pista.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);

    if (window.ResizeObserver) {
      new ResizeObserver(aggiorna).observe(pista);
    }

    aggiorna();
    return true;
  }

  /* Qui sta il punto delicato, ed e' costato due giri a capirlo.

     Primo inganno: il contenuto dei pannelli non c'e' al caricamento. Quando
     questo script parte i .mega-menu esistono gia', ma dentro non c'e' ancora
     nessun .mega-menu__list, quindi non c'e' niente su cui montare le frecce.

     Secondo inganno, peggiore: il tema **rifa'** la testata dopo averla
     costruita. Le frecce vengono montate davvero, e un attimo dopo spariscono
     insieme al markup vecchio. Un osservatore che si stacca appena ha finito
     il lavoro non se ne accorge mai, e il risultato e' un pannello senza
     frecce che pero' in teoria era stato preparato.

     Percio' l'osservatore non si stacca: resta in ascolto e rimonta le frecce
     ogni volta che il markup viene rifatto. Costa poco, perche' il lavoro vero
     lo fa una sola volta per binario (la marcatura in dataset) e le chiamate
     sono raggruppate in un frame.

     Il rinvio a requestAnimationFrame serve anche a non avvitarsi: aggiungere
     le frecce e' a sua volta una mutazione, che rientrerebbe qui. */

  var inCoda = false;

  function scansiona() {
    var pannelli = document.querySelectorAll('.mega-menu');
    for (var i = 0; i < pannelli.length; i++) prepara(pannelli[i]);
  }

  function scansionaPiuTardi() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      scansiona();
    });
  }

  function avvia() {
    // contatore di controllo: se in console window.cubeMegamenuAvviato e'
    // undefined, questo file non e' stato eseguito affatto
    window.cubeMegamenuAvviato = (window.cubeMegamenuAvviato || 0) + 1;

    scansiona();

    if (window.MutationObserver) {
      var radice = document.getElementById('header-group') || document.body;
      new MutationObserver(scansionaPiuTardi).observe(radice, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  // rete di sicurezza per browser senza MutationObserver
  document.addEventListener('pointerover', scansionaPiuTardi, { passive: true });

  // l'editor del tema ricostruisce la testata a ogni modifica
  document.addEventListener('shopify:section:load', scansionaPiuTardi);
})();
